import BankingIcon from '@nerdwallet/react-icon/nerdwallet-brand/Banking';
import CreditCardIcon from '@nerdwallet/react-icon/nerdwallet-brand/CreditCard';
import InsuranceIcon from '@nerdwallet/react-icon/nerdwallet-brand/Insurance';
import InvestmentIcon from '@nerdwallet/react-icon/nerdwallet-brand/Investment';
import MortgageIcon from '@nerdwallet/react-icon/nerdwallet-brand/Mortgage';
import PersonalLoansIcon from '@nerdwallet/react-icon/nerdwallet-brand/PersonalLoans';
import BusinessIcon from '@nerdwallet/react-icon/nerdwallet-brand/Business';
import StudentLoansIcon from '@nerdwallet/react-icon/nerdwallet-brand/StudentLoans';
import TravelIcon from '@nerdwallet/react-icon/nerdwallet-brand/Travel';

const BANKING = {
  id: 'banking',
  title: 'Banking',
  icon: BankingIcon,
  subtitle: 'Find a bank for the way you save',
  description:
    'Keep your cash in a bank account that fits your needs.  Compare options and dig into the details with objective reviews that help you make smart decisions.',
  primaryButtonText: 'compare savings accounts',
  primaryButtonUrl: '/best/banking/high-yield-online-savings-accounts',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/banking',
};

const CREDIT_CARD = {
  id: 'credit_cards',
  title: 'Credit cards',
  icon: CreditCardIcon,
  subtitle: 'The right credit card is right here',
  description:
    'Looking for a card that earns travel points, cash back, or rewards? Our side-by-side comparisons and objective reviews can help you make the smartest decision.',
  primaryButtonText: 'compare credit cards',
  primaryButtonUrl: '/the-best-credit-cards',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/credit-cards',
};

const INSURANCE = {
  id: 'insurance',
  title: 'Insurance',
  icon: InsuranceIcon,
  subtitle: 'Discover the right insurance for you',
  description:
    'Compare and find insurance for your life, home, car, and more. Our comparisons and objective reviews can help you decide on the smartest insurance carriers for you.',
  primaryButtonText: 'compare car insurance',
  primaryButtonUrl: '/a/insurance/car-insurance',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/insurance',
};

const INVESTING = {
  id: 'investing',
  title: 'Investing',
  icon: InvestmentIcon,
  subtitle: 'Zero in on investments that fit you',
  description: `Whether you're looking at stocks, IRAs, or crypto, our comparisons and objective reviews can help you make strategic decisions about your next investment accounts.`,
  primaryButtonText: 'compare online brokers',
  primaryButtonUrl: '/best/investing/online-brokers-for-stock-trading',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/investing',
};

const MORTGAGES = {
  id: 'mortgages',
  title: 'Mortgages',
  icon: MortgageIcon,
  subtitle: 'Home loans that match your goals',
  description:
    'Buying or refinancing a home? Our rate comparisons, mortgage insights, and objective lender reviews can help you make the smartest home-financing decision.',
  primaryButtonText: 'compare mortgage quotes',
  primaryButtonUrl: '/mortgages/top-mortgage-lenders',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/mortgages',
};

const PERSONAL_LOANS = {
  id: 'personal_loans',
  title: 'Personal Loans',
  icon: PersonalLoansIcon,
  subtitle: 'Borrow wisely with the right loan',
  description: `When you need a personal loan, it's smart to shop around. Our loan comparisons, objective reviews, and payment calculators make it easier to choose one with confidence.`,
  primaryButtonText: 'compare personal loans',
  primaryButtonUrl: '/personal-loans/pre-qualify',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/personal-loans',
};

const SMALL_BUSINESS = {
  id: 'small_business',
  title: 'Small Business',
  icon: BusinessIcon,
  subtitle: 'Your right fit for financing is here',
  description:
    'Find and compare SBA loans, invoice financing, and other options for your business. Personalized matches and objective reviews help you make the smartest decision.',
  primaryButtonText: 'compare business loans',
  primaryButtonUrl: '/small-business-loans',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/small-business',
};

const STUDENT_LOANS = {
  id: 'student_loans',
  title: 'Student Loans',
  icon: StudentLoansIcon,
  subtitle: 'Find the right student loan for you',
  description:
    'Need help paying for college? Compare offers from multiple private lenders and make smart borrowing decisions with objective reviews and loan calculators.',
  primaryButtonText: 'compare student loans',
  primaryButtonUrl: '/best/loans/student-loans/private-student-loans',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/student-loans',
};

const TRAVEL = {
  id: 'travel',
  title: 'Travel',
  icon: TravelIcon,
  subtitle: 'Get rewards for the way you travel',
  description:
    'Want to earn more points or miles? Our straightforward comparisons and objective reviews can help you decide which rewards programs best match your travel style.',
  primaryButtonText: 'compare rewards cards',
  primaryButtonUrl: '/best/credit-cards/travel',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/travel',
};

const TRAVEL_VARIANT = {
  id: 'travel',
  title: 'Travel',
  icon: TravelIcon,
  subtitle: 'Find travel products that fit your style',
  description:
    'Whether you want to travel comfortably or earn rewards, the right products are out there for you! Our straightforward comparisons and objective reviews can help you sure up your travel plans and save cash.',
  primaryButtonText: 'compare travel cards',
  primaryButtonUrl: '/recommend?primaryGoal=travel',
  secondaryButtonText: 'Explore guides and tips',
  secondaryButtonUrl: '/hub/category/travel',
};

export const VERTICALS = {
  BANKING,
  CREDIT_CARD,
  INSURANCE,
  INVESTING,
  MORTGAGES,
  PERSONAL_LOANS,
  SMALL_BUSINESS,
  STUDENT_LOANS,
  TRAVEL,
  TRAVEL_VARIANT,
};
